import ContactNumberSection from "./contact-number-section/contact-number-section";
import ContactDetilasEmailSection from "./email-section/email-section";
import ContactDetailsInfoBoxSection from "./info-box-section/contact-detail-info-box";
import { useContactDetailsContext } from "../../../provider/contact-details.provider";

function ContactDetailForm() {
  const { formErrors, refs } = useContactDetailsContext();

  const { errorEmailMessage, invalidPhoneMessage } = formErrors;

  const { emailRef, phoneRef } = refs;

  return (
    <form>
      <ContactDetilasEmailSection
        emailRef={emailRef}
        errorEmailMessage={errorEmailMessage}
      />
      <ContactDetailsInfoBoxSection />
      <ContactNumberSection
        invalidPhoneMessage={invalidPhoneMessage}
        phoneRef={phoneRef}
      />
    </form>
  );
}
export default ContactDetailForm;
